// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as Data14 from "common/src/data/Data14.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as SupSection from "./SupSection.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function SupAugments$AugmentCard(Props) {
  var augId = Props.augId;
  var augmentsT = Translation.useT(/* Augments */4);
  return React.createElement(ContentSection.make, {
              className: "pt-3 pb-2",
              children: null
            }, React.createElement("div", {
                  className: "flex items-center gap-2 pb-2"
                }, React.createElement(AugmentImage.make, {
                      augId: augId,
                      size: 40
                    }), React.createElement("div", {
                      className: "font-montserrat font-medium"
                    }, augmentsT(augId))), React.createElement(RitoDescription2.make, {
                  desc: augmentsT(augId + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var AugmentCard = {
  make: SupAugments$AugmentCard
};

function SupAugments(Props) {
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return true;
      });
  var setShowAll = match[1];
  var showAll = match[0];
  var allAugments = React.useMemo((function () {
          if (showAll) {
            return Js_dict.entries(Data14.augments);
          } else {
            return Belt_Array.keep(Js_dict.entries(Data14.augments), (function (param) {
                          return Belt_Option.isNone(Js_dict.get(Data13.augments, param[0]));
                        }));
          }
        }), [showAll]);
  var silverAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 1;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  var goldAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 2;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  var prismAugments = React.useMemo((function () {
          return Belt_SortArray.stableSortBy(Belt_Array.keep(allAugments, (function (param) {
                            return param[1].rank === 3;
                          })), (function (param, param$1) {
                        return Caml.caml_string_compare(param[1].name, param$1[1].name);
                      }));
        }), [allAugments]);
  return React.createElement(SupSection.make, {
              children: null,
              id: "set-update-augments",
              title: t("Augments")
            }, React.createElement("div", {
                  className: "bg-bg mb-6"
                }, React.createElement(Tabs, {
                      children: null,
                      value: showAll ? 1 : 2,
                      onChange: (function (param, v) {
                          return Curry._1(setShowAll, (function (param) {
                                        return v === 1;
                                      }));
                        })
                    }, React.createElement(Tab, {
                          label: t("All"),
                          value: 1
                        }), React.createElement(Tab, {
                          label: t("New"),
                          value: 2
                        }))), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(2,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(silverAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(SupAugments$AugmentCard, {
                                    augId: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))), React.createElement("div", {
                  className: "py-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(4,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(goldAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(SupAugments$AugmentCard, {
                                    augId: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))), React.createElement("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 md:grid-rows-[repeat(4,minmax(170px,auto))] gap-8"
                }, Belt_Array.map(prismAugments, (function (param) {
                        var augId = param[0];
                        return React.createElement(SupAugments$AugmentCard, {
                                    augId: augId,
                                    info: param[1],
                                    key: augId
                                  });
                      }))));
}

var pageSize = 12;

var make = SupAugments;

export {
  AugmentCard ,
  pageSize ,
  make ,
  
}
/* react Not a pure module */
